import script from "./LoadingOverlayComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingOverlayComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoadingOverlayComponent.vue?vue&type=style&index=0&id=2a376805&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a376805"]])

export default __exports__